import { globalOptions } from 'Dictionaries/imports/importOptionsDictionary.js';

let opts = _.merge(
    {
        parameters: {
            description: window.i18n.__(
                "Cette section vous permet de déterminer les critères sur lesquels nous allons déterminer si une déclinaison ou un produit existe déjà dans vos données Sellsy"
            ),
        },
        identifiers: {
            'product-variation': {
                title: window.i18n.__('Critère de comparaison pour les déclinaisons'),
                multiple: false,
                choices: [
                    {
                        value: 'variation_reference',
                        label: window.i18n.__('Référence déclinaison'),
                        description: window.i18n.__(
                            'Référence de la déclinaison produit unique sur lequel la catégorie tarifaire sera mise à jour.',
                        ),
                    },
                    {
                        value: 'variation_id',
                        label: window.i18n.__('Identifiant déclinaison'),
                        description: window.i18n.__(
                            'Récupéré uniquement depuis un export Sellsy.',
                        ),
                    },
                ],
            },
            product: {
                title: window.i18n.__('Critère de comparaison pour les produits'),
                multiple: false,
                choices: [
                    {
                        value: 'reference',
                        label: window.i18n.__('Référence produit'),
                        description: window.i18n.__(
                            'Référence ou code du produit unique',
                        ),
                    },
                    {
                        value: 'id',
                        label: window.i18n.__('Identifiant produit'),
                        description: window.i18n.__(
                            'Récupéré uniquement depuis un export Sellsy.',
                        ),
                    },
                ],
            },
        },
    },
    globalOptions
);

delete(opts.parameters.create);
delete(opts.parameters.update.options.overwrite_tags);

export const options = opts;

export const defaultOptions = {
    identifiers: {
        'product-variation': ['variation_reference'],
        'product': ['reference'],
    },
};

